var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.selectType,_vm._b({ref:"select",tag:"component",on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"change":_vm.handleChange},model:{value:(_vm.agValue),callback:function ($$v) {_vm.agValue=$$v},expression:"agValue"}},'component',_vm.componentProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }